import { Scene2DUnit } from '../../modules/3d/scene2d/scene2DUnit';
import { Scene3DUnit } from '../../modules/3d/scene3d/scene3DUnit';
import { SceneGroupUnit } from '../../modules/3d/sceneGroup/sceneGroupUnit';
import { SceneZoneUnit } from '../../modules/3d/sceneZone/sceneZoneUnit';
import { RendererUnit } from '../../modules/3d/rendererUnit';

export const SCENES = {
	INIT: 'INIT',
	ORTHO: '2D',
	PERS: '3D',
	GROUP: 'GROUP',
	ZONE: 'ZONE'
};

export class SceneManager {
	constructor( modules, managers ) {
		this.modules = modules;
		this.managers = managers;
		this.managers.SceneManager = this;
		this.renderUnit = null;
		this.scene2DUnit = null;
		this.scene3DUnit = null;
		this.sceneGroupUnit = null;
		this.sceneZoneUnit = null;

		this.fps = 30;
	}

	async init( grid ) {

		const container = document.getElementById( 'center-pane' );

		this.renderUnit = new RendererUnit();
		await this.renderUnit.init( container );

		this.scene2DUnit = new Scene2DUnit( this.renderUnit );
		await this.scene2DUnit.init( grid, container );

		this.scene3DUnit = new Scene3DUnit( this.renderUnit );
		await this.scene3DUnit.init( grid, container );

		this.sceneGroupUnit = new SceneGroupUnit( this.renderUnit );
		await this.sceneGroupUnit.init( container );

		this.sceneZoneUnit = new SceneZoneUnit( this.renderUnit );
		await this.sceneZoneUnit.init( grid, container );

		this.setScene( SCENES.ORTHO );
		
		//we set to render at 30fps
		this.renderUnit._loop.start();
	}

	/// setScene
	/// @param {SCENES} scene_type - SCENES
	setScene( scene_type = SCENES.ORTHO ) {

		let camera, scene;
		switch ( scene_type ) {
			case SCENES.ORTHO: {
				camera = this.scene2DUnit.camera;
				scene = this.scene2DUnit.scene;
			} break;
			case SCENES.PERS: {
				camera = this.scene3DUnit.camera;
				scene = this.scene3DUnit.scene;
			} break;
			case SCENES.GROUP: {
				camera = this.sceneGroupUnit.camera;
				scene = this.sceneGroupUnit.scene;
			} break;
			case SCENES.ZONE: {
				camera = this.sceneZoneUnit.camera;
				scene = this.sceneZoneUnit.scene;
			} break;
		}
		this.renderUnit.scene = scene;
		this.renderUnit.camera = camera;

		this.scene2DUnit.setEnabled( scene_type === SCENES.ORTHO );
		this.scene3DUnit.setEnabled( scene_type === SCENES.PERS );
		this.sceneGroupUnit.setEnabled( scene_type === SCENES.GROUP );
		this.sceneZoneUnit.setEnabled( scene_type === SCENES.ZONE );
	}

	resize( size ) {
		
		//update cameras to fix aspect deformation
		this.scene2DUnit.camera.aspect = size.width / size.height;
		this.scene2DUnit.camera.updateProjectionMatrix();

		this.scene3DUnit.camera.aspect = size.width / size.height;
		this.scene3DUnit.camera.updateProjectionMatrix();

		this.sceneGroupUnit.camera.aspect = size.width / size.height;
		this.sceneGroupUnit.camera.updateProjectionMatrix();

		this.sceneZoneUnit.camera.aspect = size.width / size.height;
		this.sceneZoneUnit.camera.updateProjectionMatrix();

		this.render();
	}

	render() {
		this.renderUnit.render();
	}
}